function updateCountdown() {
  const endDate = document.querySelector('.offer-countdown').getAttribute('data-end-date');
  const now = new Date().getTime();
  const distance = new Date(endDate).getTime() - now;
  // Calculate days, hours, minutes
  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

  // Display the result in HTML elements (e.g., span or div elements)
  document.getElementById('days').innerText = days;
  document.getElementById('hours').innerText = hours;
  document.getElementById('minutes').innerText = minutes;
}

setInterval(() => {
  updateCountdown();
}, 1000);
